var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#EC2929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.832 6.816H12.536C13.8053 6.816 14.8187 7.152 15.576 7.824C16.3333 8.48533 16.712 9.408 16.712 10.592C16.712 11.808 16.3333 12.7413 15.576 13.392C14.8293 14.0427 13.816 14.368 12.536 14.368H10.264V18H7.832V6.816ZM12.184 12.336C13.56 12.336 14.248 11.7547 14.248 10.592C14.248 9.94133 14.0613 9.488 13.688 9.232C13.3253 8.976 12.824 8.848 12.184 8.848H10.264V12.336H12.184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.6745936c83fd470ea56310876e5f313c.svg";
export { ForwardRef as ReactComponent };